var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('notifications',{attrs:{"group":"errors","ignoreDuplicates":true,"max":1,"role":"status"}}),_c('notifications',{attrs:{"group":"notices","ignoreDuplicates":true,"max":1,"role":"status"}}),_c('NavigationView'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }